import React from 'react';
import settingsManager from 'core/managers/settings';

export default class extends React.Component {
  render() {
    return <span>{settingsManager.get('siteName')}</span>;
  }
}
